export default __webpack_public_path__ + "static/media/Social Links.b6e5ac58.svg";